import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { User } from 'src/app/models/users.model';
import { HttpClient } from '@angular/common/http';
import { SharedService } from '../../services/shared.service';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { environment } from 'src/environments/environment';
import { NgForm } from '@angular/forms';
import { IPlan } from 'src/app/models/plan.model';
import { IPriceInfo } from '../../../models/price-info.model';

@Component({
  selector: 'app-card-details',
  templateUrl: './card-details.component.html',
  styleUrls: ['./card-details.component.scss'],
})
export class CardDetailsComponent implements OnInit {
  environment = environment;

  @Input()
  plan: IPlan;

  @Input()
  priceInfo: IPriceInfo;

  @ViewChild('cardForm')
  cardForm: NgForm;

  user: User;
  loading = false;
  isPayClicked = false;

  constructor(
    private http: HttpClient,
    private ss: SharedService,
    protected dialogRef: NbDialogRef<CardDetailsComponent>,
    protected toastr: NbToastrService,
  ) {}

  async ngOnInit() {
    this.loading = true;
    this.user = await this.ss.getUser();

    await this.setupPeach();
    setTimeout(() => {
      this.loading = false;
    }, 3000);
  }

  async setupPeach() {
    const peachCheckoutId = await this.getPeachCheckoutId();
    const peachCheckoutURL = environment.production
      ? 'https://oppwa.com/v1/paymentWidgets.js?checkoutId=' + peachCheckoutId
      : 'https://test.oppwa.com/v1/paymentWidgets.js?checkoutId=' + peachCheckoutId;
    const scriptOptions = document.createElement('script');
    scriptOptions.type = 'text/javascript';
    // See https://peachpayments.docs.oppwa.com/tutorials/integration-guide/widget-api for options
    scriptOptions.text = `
    var wpwlOptions = {
      labels: {
        submit: 'Pay ${this.priceInfo.currencySymbol} ${this.priceInfo.price}'
      },
    }
    `;
    document.getElementsByTagName('head')[0].appendChild(scriptOptions);
    const scriptCard = document.createElement('script');
    scriptCard.type = 'text/javascript';
    scriptCard.src = peachCheckoutURL;
    document.getElementsByTagName('head')[0].appendChild(scriptCard);
  }

  submit() {
    console.log('submitted');
  }

  async getPeachCheckoutId(): Promise<string> {
    try {
      // TODO rather use planId and User currency then on backend handle amount
      const res = (await this.http
        .post(`${environment.functionsRootUrl}/peach-getCheckoutId/getCheckoutId`, {
          planId: this.plan.uid,
          currency: this.priceInfo.currencyCode,
        })
        // .post(`${environment.functionsRootUrl}/peach-getCheckoutId/getCheckoutId`, { amount: this.priceInfo.price })
        .toPromise()) as any;
      return res.id;
    } catch (error) {
      console.error(error);
    }
  }

  // TODO EFT only for `this.user.countryCode = ZA`
  async eftClicked() {
    this.loading = true;
    try {
      // TODO rather use planId and User currency then on backend handle amount
      const url = await this.getPaymentKeyURL(this.plan.credits, this.priceInfo.price);
      window.location.href = url;
    } catch (error) {
      console.error(error);
      this.toastr.warning(error.message || error, 'Oops ...');
      this.loading = false;
    }
  }

  async getPaymentKeyURL(numOfCreditsToPurchase: number, costOfPurchaseRand: number): Promise<string> {
    try {
      const res = (await this.http
        .post(`${environment.functionsRootUrl}/peach-getPaymentKey/`, {
          randAmount: costOfPurchaseRand,
          totalCredits: numOfCreditsToPurchase,
          userUid: this.user.uid,
        })
        .toPromise()) as { url: string; key: string };

      return res.url;
    } catch (error) {
      console.error(error);
    }
  }
}
